import type { CustomerStatus } from '@/api/client'
import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { useTranslation } from 'react-i18next'

interface Props {
  status: CustomerStatus
}

const variants: Record<CustomerStatus, BadgeVariant> = {
  active: 'success',
  suspended: 'warning',
  archived: 'outline',
}

export function StatusBadge({ status }: Props) {
  const { t } = useTranslation('common')
  return (
    <Badge variant={variants[status]} withDot>
      {t(`customers.status.${status}`, { defaultValue: status })}
    </Badge>
  )
}
